import { LogGroup, Log } from "../.././MyHelpers";
export class Anticipation {
	public speed: number = 0;
	public defaultDuration: number = 0;
	public defaultDistance: number = 0;

	public targetDuration: number = 0;
	public targetDistance: number = 0;

	public currentDistance: number = 0;

	protected logGroup: LogGroup;

	public constructor(logGroup: LogGroup)
	{
		this.logGroup = logGroup.Add("Anticipation");
	}

	public CalculateDistance(time: number): number {
		return this.speed * time;
	}

	public SetTargetDistance(targetDistance: number): boolean {
		let success: boolean = false;

		if (targetDistance >= this.currentDistance) {
			this.targetDistance = targetDistance;
			this.targetDuration = targetDistance / this.speed;

			success = true;
		}
		else {
			Log.Error("ANTICIPATION", "Can't set target distance to past position");
		}

		return success;
	}

	public Reset(): void {
		this.targetDistance = this.defaultDistance;
		this.targetDuration = this.defaultDuration;
	}
}